import { CircularProgress, Grid, Stack, styled } from "@mui/material";

import SrcCoin from "pages/Market/Component/TableMarket/components/SrcCoin";
import Table from "components/Table";
import Price from "pages/Market/Component/TableMarket/components/Price";

const headers = [
  {
    key: "srcCoin",
    align: "left",
    name: "Coin",
    sortable: true,
    sortKey: "coinSourceName",
  },
  {
    key: "price",
    align: "left",
    name: "Price",
  },
];

export function TableDrawer({
  hideBorders = false,
  onRowClick,
  coinList,
  loading
}) {
  const formattedDataList = coinList?.map((data) => {
    return {
      data: data,
      srcCoin: <SrcCoin data={data} />,
      price: <Price data={data} />,
    };
  });


  return (
    <Grid item xs={12} marginTop={3}>
      {!loading ? (
        <Table
          dense
          onRowClick={onRowClick}
          hideBorders={hideBorders}
          headers={headers}
          items={formattedDataList}
        />
      ) : (
        <StackStyle spacing={2} direction="row">
          <CircularProgress color="secondary" />
        </StackStyle>
      )}
    </Grid>
  );
}


const StackStyle = styled(Stack)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
}));

export default TableDrawer;
